"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../../axios-client/axios-client.service");
var user_company_user_promotions_const_1 = require("./user-company-user-promotions.const");
/**
 * UserCompanyUserPromotions
 * @class
 */
var UserCompanyUserPromotions = /** @class */ (function () {
    function UserCompanyUserPromotions() {
    }
    /**
     * Returns referral info of a user (`userUuid`)
     * @param user {string}
     * @returns
     */
    UserCompanyUserPromotions.prototype.getReferralInfo = function (userUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_promotions_const_1.USER_COMPANY_USER_PROMOTIONS_ENDPOINT.getReferralInfo
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a promotion by (`promotionCode`) of an opertator (`csOperatorUuid`)
     * @param promotion {string}
     * @param csOperatorUuid {string}
     * @returns
     */
    UserCompanyUserPromotions.prototype.checkPromotion = function (promotionCode, csOperatorUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_promotions_const_1.USER_COMPANY_USER_PROMOTIONS_ENDPOINT.checkPromotion
            .replace('{{version}}', version)
            .replace('{{promotionCode}}', promotionCode)
            .replace('{{csOperatorUuid}}', csOperatorUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Creates a friend invitation by user (`userUuid`)
     * @param userUuid {string}
     * @param data <Invitation>
     * @returns
     */
    UserCompanyUserPromotions.prototype.postInviteAFriend = function (userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_promotions_const_1.USER_COMPANY_USER_PROMOTIONS_ENDPOINT.postInviteAFriend
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Binds promotion code (`promotionCode`) to a user (`userUuid`)
     * @param userUuid {string}
     * @param promotionCode {string}
     * @returns
     */
    UserCompanyUserPromotions.prototype.addPromotionCode = function (userUuid, promotionCode, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_promotions_const_1.USER_COMPANY_USER_PROMOTIONS_ENDPOINT.addPromotionCode
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid)
            .replace('{{promotionCode}}', promotionCode);
        return axios_client_service_1.axiosClientInstance.post(url);
    };
    return UserCompanyUserPromotions;
}());
/**
 * External UserCompanyUserPromotions Class Instance
 * @namespace
 */
exports.userCompanyUserPromotions = new UserCompanyUserPromotions();
